<template>
    <div>
        <main class="main-content">
        <div class="page-content">
          <div class="container">
            <div class="page-links">
                    <router-link to="/climbing/camps" class="page-links__item">Camps & Heights</router-link>
                    <router-link to="/climbing/distance" class="page-links__item is-active">Distance & Time</router-link>
                    <router-link to="/climbing/temperature" class="page-links__item">Temperature</router-link>
                    <router-link to="/climbing/moon" class="page-links__item">Moon Phases</router-link>
                </div>
                <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
            <section class="kilimanjaro-settings kilimanjaro-settings--distance">
              <div class="page-title  page-title_select" v-if="isLoad">
                <h2>Distance and Time</h2>
                <div class="form-control-group form-control-group_mounts-2" v-if="mountains.find(item => item.active)"><span class="form-control-label">Mount</span>
                  <div :class="['select-wrapper select-wrapper', {'is-active' : mountSelect}]" @click="mountSelect = !mountSelect;distanses = distanses.map((distanse, i) => ({...distanse, to: false, from: false}))">
                        <div class="select-trigger"><span class="select-trigger__name">{{mountains.find(item => item.active).title}}</span><span class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span></div>
                        <div class="select-body">
                            <div class="select-inner js-scrollbar">
                            <div 
                                v-for="item in mountains"
                                :key="item.id"
                                :class="['select-option', { 'is-selected': item.active }]"
                                @click="mountains = mountains.map(mount => ({...mount, active: mount.id === item.id}))"><span class="select-option__name">{{item.title}}</span></div>
                            </div>
                        </div>
                        </div>
                </div>
              </div>
              <form action="javascript:void(0" class="kilimanjaro-settings__form" v-if="isLoad">
                <div class="kilimanjaro-settings__table">
                  <div class="section-table-wrap">
                    <div class="section-table section-table--distance">
                      <div class="section-table__head">
                        <div class="col col-from"><span>From</span></div>
                        <div class="col col-to"><span>To</span></div>
                        <div class="col col-distance"><span>Distance (m)</span></div>
                        <div class="col col-time"><span>Time (min)</span></div>
                        <div class="col col-action"></div>
                      </div>
                      <div class="section-table__body">
                        <div class="section-table__row" v-for="(item, index) in distanses" :key="item.id">
                          <div class="col col-destination">
                            <div class="form-select-group">
                              <div class="form-control-group">
                                <div :class="['select-wrapper', {'is-active' : item.from}]" @click="distanses = distanses.map((distanse, i) => ({...distanse, from: index === i ? !distanse.from : false, to: false}));mountSelect = false" v-if="camps.find(camp => camp.id === item.campFromId)">
                                  <div class="select-trigger"><span class="select-trigger__name">{{camps.find(camp => camp.id === item.campFromId).names.EN}}</span><span class="select-trigger__icon">
                                      <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                      </svg></span></div>
                                  <div class="select-body">
                                    <div class="select-inner">
                                        <div v-for="camp in camps" :key="camp.id" :class="['select-option', {'is-selected' : camp.id === item.campFromId }]" @click="item.campFromId = camp.id;isEdit = true">
                                            <span class="select-option__name">{{camp.names.EN}}</span>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="form-select-group__divider">
                                <svg width="1em" height="1em" class="icon icon-arrow ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>
                                </svg>
                              </div>
                              <div class="form-control-group">
                                <div :class="['select-wrapper', {'is-active' : item.to}]"  @click="distanses = distanses.map((distanse, i) => ({...distanse, to: index === i ? !distanse.to : false, from: false}));mountSelect = false" v-if="camps.find(camp => camp.id === item.campFromId)">
                                  <div class="select-trigger"><span class="select-trigger__name">{{camps.find(camp => camp.id === item.campToId).names.EN}}</span><span class="select-trigger__icon">
                                      <svg width="1em" height="1em" class="icon icon-chevron ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                      </svg></span></div>
                                  <div class="select-body">
                                    <div class="select-inner">
                                        <div v-for="camp in camps" :key="camp.id" :class="['select-option', {'is-selected' : camp.id === item.campToId }]" @click="item.campToId = camp.id;isEdit = true">
                                            <span class="select-option__name">{{camp.names.EN}}</span>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col col-distance">
                            <div class="form-control-group">
                              <div class="form-control-wrap">
                                <input type="number" placeholder="Distance" @input="isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" v-model="item.distance" class="form-control"/>
                              </div>
                            </div>
                          </div>
                          <div class="col col-time">
                            <div class="form-control-group">
                              <div class="form-control-wrap">
                                <input type="number" placeholder="Time" @input="isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" v-model="item.timeMin" class="form-control"/>
                              </div>
                            </div>
                          </div>
                          <div class="col col-action">
                            <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                    entity: 'Point',
                                    name: 'this',
                                    handler: deleteDistanse,
                                    id: index
                                })">
                              <svg width="1em" height="1em" class="icon icon-close ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="kilimanjaro-settings__add">
                  <button type="button" class="btn btn--rounded" @click="createDistance"><span>Add</span></button>
                </div>
                <div class="kilimanjaro-settings__submit">
                  <button type="button" class="btn btn--green" @click="saveDistances"><span>Save</span></button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </main>
    </div>
</template>

<script>

    import { 
        getDistances,
        updateDistances,
        getCamps,
		getMountains
    } from '@/utilites/api'

    export default {
        data(){
            return { 
                distanses: [],
                camps: [],
				mountains: [],
                mountSelect: false,
                isLoad: false,
				isEdit: false
            }
        },
		beforeRouteLeave(to, from, next){
			if(this.isEdit){
				this.$emit('notLeaveHandler')
			}
			next()
		},
    beforeCreate(){
           document.title = 'Climbing / Distance & Time'
        },
        props: ['user'],
        mounted(){
            document.title = 'Climbing / Distance & Time'
		    getMountains(this.user.access_token)
            .then(res => {
                this.mountains = res.map((item, index) => ({...item, active: index === 0}))
            })
			.catch(() => {
				this.isLoad = true
			})
			window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.mountSelect = false
					this.distanses = this.distanses.map((distanse, i) => ({...distanse, to: false, from: false}))
                }
            })
        },
        methods: {
			checkErrors(){
				let error = false
				document.querySelectorAll('input[type="number"]').forEach(elem => {
					if(elem.value.trim().length === 0 || elem.value <= 0){
						elem.parentElement.classList.add('is-error')
						error = true
					}
				})
				return error
			},
            deleteDistanse(id){
                this.distanses = this.distanses.filter((item, index) => !(index=== id))
				this.isEdit = true
            },
            createDistance(){
				if(this.camps[0]){
					this.distanses = this.distanses.concat({
						id: Date.now(),
						campFromId: this.camps[0].id,
						campToId: this.camps[0].id,
						distance: '',
						timeMin: '',
						isNew: true, 
						from: false, 
						to: false
					})
					this.isEdit = true
				}
            },
            updateData(id){
                getDistances(this.user.access_token, id)
                .then(res => {
                    this.distanses = res.map(item => ({...item, from: false, to: false}))
					this.isLoad = true
                })
				.catch(() => {
					this.isLoad = true
					this.distanses = []
				})
				getCamps(this.user.access_token, id)
				.then(res => {
					this.camps = res
				})
				.catch(() => {
					this.isLoad = true
				})
            },
            saveDistances(){
				if(!this.checkErrors()){
					 updateDistances(this.user.access_token, this.distanses.map(item => item.isNew ? { campFromId: item.campFromId, campToId: item.campToId, distance: item.distance, timeMin: item.timeMin } : {campFromId: item.campFromId, campToId: item.campToId, distance: item.distance, timeMin: item.timeMin, id: item.id}), this.mountains.find(item => item.active).id)
					.then(() => {
						this.$emit('confirmed')
						this.isEdit = false
						this.updateData(this.mountains.find(item => item.active).id)
					})
					.catch(() => this.$emit('errored'))
				}
            }
        },
		watch: {
            mountains(){
				this.isLoad = false
                let id = this.mountains.find(item => item.active).id
                this.updateData(id)
            }
        }
    }

</script>